import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import { cloneDeep, isEmpty, pick, uniqueId } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useRecoilState, useSetRecoilState } from "recoil";
import { domainListAtom, modalAtom } from "../../containers/App/App.state";
import { getElements } from "../../helpers/services/ContractServices";
import { domainFormValidation } from "../../helpers/validations";
import FlokkButton from "../FlokkButton";
import Key from "../form-fields/Key";
import Switch from "../form-fields/Switch";

const menu_id = 1711;
const translationPath = "flokk_onlinedomain";
const defaultInitialValues = {
  domain: "",
  country_id: {
    id: 288,
    short_name: "Deutschland",
  },
  verified_logistics_flag: false,
  verified_service_flag: false,
};

const useDomainFormStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gap: theme.spacing(4),
    gridTemplateColumns: "1fr 1fr",
  },
}));

const DomainForm = (props) => {
  const { row } = props;
  const classes = useDomainFormStyles();
  const { t } = useTranslation();
  const [{ trader_company_id, domains }, setDomains] =
    useRecoilState(domainListAtom);
  const setModal = useSetRecoilState(modalAtom);

  function onSubmit(data) {
    let formData = {
      ...pick(data, [
        "domain",
        "verified_logistics_flag",
        "verified_service_flag",
      ]),
      country_id: data.country_id.id,
      country_id_short_name: data.country_id.short_name,
    };

    if (row?.id) {
      const domainIndex = domains.findIndex((domain) => domain.id === row.id);
      const clonedDomains = cloneDeep(domains);
      const newData = {
        ...clonedDomains[domainIndex],
        ...formData,
        _state: typeof row["id"] === "number" ? "edit" : "add",
      };
      clonedDomains[domainIndex] = newData;
      setDomains({
        trader_company_id,
        domains: clonedDomains,
      });
    } else {
      setDomains({
        trader_company_id,
        domains: [
          ...domains,
          {
            id: uniqueId("temp_"),
            ...formData,
            _state: "add",
          },
        ],
      });
    }

    setModal({
      title: "",
      content: null,
    });
  }

  const { isLoading, data } = useQuery({
    queryKey: ["Elements", row],
    queryFn: () => getElements(menu_id),
  });

  const editInitialValues = {
    ...pick(row, [
      "domain",
      "verified_logistics_flag",
      "verified_service_flag",
    ]),
    country_id: {
      id: row?.country_id,
      short_name: row?.country_id_short_name,
    },
  };

  const {
    handleSubmit,
    setFieldValue,
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
  } = useFormik({
    initialValues: row ? editInitialValues : defaultInitialValues,
    onSubmit: onSubmit,
    validationSchema: domainFormValidation,
  });

  if (isLoading || isEmpty(data)) {
    return null;
  }

  function handleKeyChange(value) {
    setFieldValue("country_id", value);
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className={classes.root}>
          <TextField
            variant="outlined"
            id="domain"
            name="domain"
            label={t(translationPath + ".domain")}
            value={values.domain}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.domain && touched.domain}
            helperText={errors.domain}
          />

          <Key
            id="country_id"
            label={t(translationPath + ".country_id")}
            value={values.country_id}
            onChange={handleKeyChange}
            onBlur={handleBlur}
            readonly={true}
            error={errors.country_id && touched.country_id}
            helperText={errors.country_id}
            meta_id={
              data.find((el) => el.label === "country_id")?.meta_id || ""
            }
          />

          <Switch
            name="verified_logistics_flag"
            label={t(translationPath + ".verified_logistics_flag")}
            value={values.verified_logistics_flag}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              errors.verified_logistics_flag && touched.verified_logistics_flag
            }
            helperText={errors.verified_logistics_flag}
          />

          <Switch
            name="verified_service_flag"
            label={t(translationPath + ".verified_service_flag")}
            value={values.verified_service_flag}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              errors.verified_service_flag && touched.verified_service_flag
            }
            helperText={errors.verified_service_flag}
          />
        </div>
        <br />
        <br />
        <br />
        <FlokkButton color="primary" type="submit" variant="contained">
          {t("system.save_btn")}
        </FlokkButton>
        <br />
        <br />
      </form>
    </div>
  );
};

export default DomainForm;
